import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

const propTypes = {
  label: PropTypes.string.isRequired,
  previewUrl: PropTypes.string.isRequired,
};

const MarketingMaterialSample = ({ label, previewUrl }) => {
  return (
    <Fragment>
      <h3 className="text-center">Previewing: {label}</h3>
      <div className="marketing-material-sample">
        <img src={previewUrl} alt="Preview" />
      </div>
    </Fragment>
  );
};

MarketingMaterialSample.propTypes = propTypes;

export default MarketingMaterialSample;
